var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/wrench/components/mobile-nav/MobileNav.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL, getClientEnvironmentDetails } from '@sm/utils';
import { Box } from '@wds/box';
import { IconPlus } from '@wds/icons';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { Sheet } from '@wds/sheet';
import { useHeaderTheme } from '../../theme';
import { Title } from '../../components/title';
import { Logo } from '../logo';
import { SubMenuItem } from './SubMenuItem';
import { MobileMenuButton } from './MobileMenuButton';
import { signOut } from '../../../config/MobileLinkInfo.js';
import useStyles from './useStyles';
var COPY = defineMessages({
  CREATE_SURVEY_LABEL: {
    id: 'MobileNav.createSurvey',
    defaultMessage: 'Create survey icon',
    description: '[Type: Label][Vis.: low] - Create Survey plus button on mobile'
  },
  MENU_ICON_LABEL: {
    id: 'MobileNav.menuIcon',
    defaultMessage: 'Menu icon',
    description: '[Type: Label][Vis.: low] - Mobile navigation menu button icon'
  },
  CLOSE_ICON_LABEL: {
    id: 'MobileNav.closeIcon',
    defaultMessage: 'Close menu icon',
    description: '[Type: Label][Vis.: low] - Mobile navigation close button icon'
  }
});
var MobileNav = function MobileNav(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    userMenu = _ref.userMenu,
    navItems = _ref.navItems,
    link = _ref.link,
    infoMenu = _ref.infoMenu,
    create = _ref.create;
  var theme = useHeaderTheme();
  var classes = useStyles({
    title: title,
    theme: theme
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMobileNav = _useState2[0],
    setShowMobileNav = _useState2[1];
  var toggleMobileNav = function toggleMobileNav() {
    return setShowMobileNav(!showMobileNav);
  };
  var _getClientEnvironment = getClientEnvironmentDetails(),
    isDesktop = _getClientEnvironment.isDesktop;
  return /*#__PURE__*/React.createElement(Responsive, {
    maxWidth: "xl",
    defaultMatches: !isDesktop,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, create && /*#__PURE__*/React.createElement(Responsive, {
    maxWidth: "md",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: createURL('/create/', {
      ut_source: 'header'
    }),
    className: classes.createButton,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(IconPlus, {
    size: "xl",
    title: t(COPY.CREATE_SURVEY_LABEL),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.mobileNavContainer,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.mobileNavBoxFull,
    display: "flex",
    flexAlign: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "md",
    defaultMatches: !isDesktop,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileMenuButton, {
    showMobileNav: showMobileNav,
    toggleMobileNav: toggleMobileNav,
    testid: "tablet-menu-button",
    left: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(Logo, {
    link: link,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Responsive, {
    maxWidth: "md",
    defaultMatches: !isDesktop,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileMenuButton, {
    showMobileNav: showMobileNav,
    toggleMobileNav: toggleMobileNav,
    left: !title,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.mobileNavLogo,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Logo, {
    link: link,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 19
    }
  })))), title && /*#__PURE__*/React.createElement(Title, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 23
    }
  }, title)), /*#__PURE__*/React.createElement(Sheet, {
    showCloseButton: true,
    onClose: toggleMobileNav,
    show: showMobileNav,
    placement: "left",
    offsetTop: 48,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.mobileNavMenu,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(List, {
    noRules: true,
    interactive: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 15
    }
  }, navItems), infoMenu, !!userMenu && /*#__PURE__*/React.createElement(Responsive, {
    maxWidth: "md",
    defaultMatches: !isDesktop,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(List, {
    interactive: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 19
    }
  }, userMenu, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, signOut(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 21
    }
  })))))))));
};
export default MobileNav;
export { MobileNav };
//# sourceMappingURL=MobileNav.js.map